import React from "react";
import worknestLogo from '../images/worknest-small.svg'
import { useAuth } from "../contexts/authContext";
import logoutIcon from '../images/logout-line.svg'
import {
    Box,
    AppBar as MuiAppBar,
    Toolbar,
    Button,
} from "@mui/material";
import { makeStyles, styled } from '@mui/styles';
import { Link } from "react-router-dom";

const AppBar = styled(MuiAppBar)(({ theme }) => ({
    color: theme.header.color,
    boxShadow: theme.shadows[1],
}));

const useStyles = makeStyles((theme) => ({
    appBar: {
        backgroundColor: '#150850',
        color: theme.header.color,
        boxShadow: theme.shadows[1],
    },
    gridItem: {
        display: 'flex'
    },
    logo: {
        height: '50px',
        width: '50px'
    },
    title: {
        color: 'white',
        textDecoration: 'none',
        fontSize: '1.25rem',
        fontWeight: '500',
        marginLeft: '10px'
    },
    button: {
        borderRadius: '100%',
        width: '35px',
        height: '35px',
        minWidth: '0px',
        background: '#eee'
    },
    buttonIcon: {
        height: '15px',
        width: '15px'
    }
}))

const Header = ({ userGuide }) => {
    const classes = useStyles()

    const { logout } = useAuth();

    return (
        <AppBar className={classes.appBar} position="sticky" elevation={0}>
            <Toolbar>
                <Box display="flex" alignItems="center" width="100%" gap={2}>
                    <img alt='logo' src={worknestLogo} className={classes.logo} />
                    <Link className={classes.title} to="/">WorkNest Tools</Link>
                    <Box flexGrow={1} />
                    {userGuide && (
                        <Button
                            size="small"
                            href={`https://worknestltd.sharepoint.com/sites/ITFacilities/SitePages/WorkNest-Tools.aspx#${userGuide}`}
                            variant="contained"
                            target="_blank"
                        >
                            User Guide
                        </Button>
                    )}
                    <Button className={classes.button} variant="contained" onClick={logout}>
                        <img className={classes.buttonIcon} alt='Logout' src={logoutIcon} />
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

export default Header;
